import { render, staticRenderFns } from "./QuoteIcon.vue?vue&type=template&id=7e4ce4e0"
import script from "./QuoteIcon.vue?vue&type=script&lang=ts"
export * from "./QuoteIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports